import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { NavBarCollapsableContext } from '../../../helpers/context'
import {
  alteraIconUrl,
  calendar,
  copy,
  deleteIcon,
  download,
  editIcon,
  logo,
  points,
  scan,
} from '../../../images'
import { useWindowSize } from '../../../helpers/hooks/hookWindowsSize'
import { useNavigate, useParams } from 'react-router-dom'
import DialogModal from '../../../components/dialogModal'
import Calendar from '../../../components/calendar'
import ByTimeDashboard from '../../../components/dashboard/byTime'
import ByCountryChart from '../../../components/dashboard/byCountry'
import QRCodeDownload from '../../../components/qrDownload'
import QRCode from 'qrcode.react'
import { toast } from 'react-toastify'
import EditQrForm from '../../../components/forms/qrCodes/formEdit'
import DeleteQrForm from '../../../components/forms/qrCodes/formDelete'
import {
  formatDate,
  formatDateLong,
  getToken,
  getTokenExpiration,
  logOut,
} from '../../../helpers/utils'
import { AppDispatch, useAppDispatch } from '../../../redux/store'
import {
  editLink,
  getLink,
  getScansPerDay,
} from '../../../redux/reducers/urlReducer'

interface EditFormValues {
  _id: string
  title: string
  qr_code: {
    color: string
    logo: string
  }
  short_url: string
  custom_code: string
  original_url: string
  domain: string
}

interface DeleteFormValues {
  id: string
}
/**Links is a view returns the components LinksCards with the urls created adn the modal for editing and deleting them */
const LinkDetail = () => {
  const { t } = useTranslation()
  const dispatch: AppDispatch = useAppDispatch()
  const classContext = useContext(NavBarCollapsableContext)
  const [openEdit, setOpenEdit] = useState(false)
  const [openDelete, setOpenDelete] = useState(false)
  const [showMenu, setShowMenu] = useState(false)
  const [chartData, setChartData] = useState([])
  const [data, setData] = useState({
    _id: '',
    original_url: '',
    short_url: '',
    title: '',
    domain: '',
    custom_code: '',
    tags: [],
    has_qr: true,
    status: 1,
    createdAt: '',
    tracking_count: 0,
    qr_code: { color: '', logo: '' },
  })

  const [openDownload, setOpenDownload] = useState(false)
  let navigate = useNavigate()
  const sizeWidth = useWindowSize().width
  const currentDate = new Date()
  const { id } = useParams()
  const urlId = id || ''
  const firstDayOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1
  )
  const [dateRange, setDateRange] = useState({
    startDate: firstDayOfMonth,
    endDate: currentDate,
  })
  const formattedFirstDayOfMonth = `${firstDayOfMonth.getFullYear()}-${(
    firstDayOfMonth.getMonth() + 1
  )
    .toString()
    .padStart(2, '0')}-01`
  const formattedDate = `${currentDate.getFullYear()}-${(
    currentDate.getMonth() + 1
  )
    .toString()
    .padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`

  const [toDateSelected, setToDateSelected] = useState<string>(formattedDate)
  const [fromDateSelected, setFromDateSelected] = useState<string>(
    formattedFirstDayOfMonth
  )
 const token = getToken()
  const sessionExpired = getTokenExpiration()

  useEffect(() => {
    if (sessionExpired) logOut()
  }, [sessionExpired])

  useEffect(() => {
    if (urlId) {
      getData(urlId)
      getDataGraph()
    }
  }, [urlId])

  const getData = async (linkId: string) => {
   
    try {
      const { payload } = await dispatch(getLink({ token: token, id: linkId }))
  
      if (payload.success) {
        setData(payload.data)
      } else {
        toast(`${t('ERROR')}`)
      }
    } catch (error) {
      console.error('Error:', error)
    }
  }

  const getDataGraph = async () => {
    try {
      const { payload } = await dispatch(
        getScansPerDay({
          token: token,
          urlId: urlId,
          from: fromDateSelected,
          to: toDateSelected,
        })
      )

      if (payload) {
        setChartData(payload?.data)
      } else {
        console.error(`${t('ERROR')}`)
      }
    } catch (error) {
      console.error('Error:', error)
    }
  }
  const handleEdit = () => {
    setOpenEdit(true)
    setShowMenu(false)
  }

  const handleEditLink = async (body: any) => {
    try {
      const { payload } = await dispatch(editLink({ token, body: body }))

      if (payload && payload.success) {
        toast(`${t('DATA_UPDATED')}`)
        getData(urlId)
      } else {
        toast(`${t('ERROR')}`)
      }
    } catch (error) {
      console.error('Error:', error)
    }
  }

  const handleSubmitEdit = (values: EditFormValues) => {
    const body = {
      urlId: values._id,
      url: values.original_url,
      domain: values.domain,
      title: values.title,
      custom_code: values.custom_code,
      has_qr: true,
      qr_code: { color: values.qr_code.color, logo: values.qr_code.logo },
      utm: null,
    }

    handleEditLink(body)
    setOpenEdit(false)
  }

  const copyLink = (url: string) => {
    navigator.clipboard.writeText(url)
    toast(`${t('LINK_COPIED')}`)
  }

  const handleMenu = () => {
    setShowMenu(!showMenu)
  }

  const onChange = (ranges: any) => {
    setDateRange(ranges)
    setFromDateSelected(ranges.startDate)
    setToDateSelected(ranges.endDate)
  }

  const handleCloseEdit = () => {
    setOpenEdit(false)
  }

  const Menu = () => {
    return (
      <div className='container-option-extra-details'>
        <button
          className='button-option-extra'
          onClick={() => setOpenDownload(true)}
        >
          <img
            src={download}
            alt={`${t('DOWNLOAD')}`}
            className='icon-option-extra'
          />
          <span className='option-extra'>{`${t('DOWNLOAD')}`}</span>
        </button>
        <hr></hr>
        <button className='button-option-extra' onClick={() => handleEdit()}>
          <img
            src={editIcon}
            alt={`${t('EDIT')}`}
            className='icon-option-extra'
          />
          <span className='option-extra'>{`${t('EDIT')}`}</span>
        </button>
        <hr></hr>
        <button
          className='button-option-extra'
          onClick={() => {
            copyLink(data?.short_url)
          }}
        >
          <img src={copy} alt={`${t('COPY')}`} className='icon-option-extra' />
          <span className='option-extra'>{`${t('COPY')}`}</span>
        </button>
      </div>
    )
  }

  return (
    <>
      <div className={`container-home`}>
        <div className={classContext.classes.navbar_padding_left}>
          <div>
            <div className='container-link-card' key={data?._id}>
              <div className='link-card'>
                <button
                  className='button-link'
                  onClick={() => navigate('/qr-codes')}
                >
                  {`${t('GO_BACK_QRS')}`}
                </button>

                <div className='link-card-icon-information pt-0 pt-md-5'>
                  <div className='container-qr-code-detail'>
                    <QRCode
                      id='qr-code'
                      value={data?.short_url}
                      fgColor={data?.qr_code.color}
                      bgColor='transparent'
                      level='H'
                      size={100}
                      imageSettings={{
                        src: data?.qr_code.logo,
                        height: 24,
                        width: 24,
                        excavate: true,
                      }}
                    />
                  </div>
                  <div className='link-content-title'>
                    <div className='d-grid'>
                      <span>{`${t(data?.title)}`}</span>
                      <a
                        className='link-card-long-url'
                        href={data?.original_url}
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        {data?.original_url}
                      </a>
                      <a
                        id='short-url'
                        defaultValue={data?.short_url}
                        className='link-card-short-url'
                        href={data?.short_url}
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        {data?.short_url}
                      </a>
                    </div>
                  </div>
                  <div className='container-url-track'>
                    <div className='container-track-card'>
                      <div className='pt-4 pt-md-0'>
                        <img
                          className='button-card-icon'
                          src={scan}
                          alt={`${t('SCANS')}`}
                        />
                        <span>{data?.tracking_count}</span>
                      </div>

                      <div className='py-4 py-md-0'>
                        <img
                          className='button-card-icon'
                          src={calendar}
                          alt={`${t('DATE')}`}
                        />

                        <span>{formatDate(data?.createdAt)}</span>
                      </div>
                    </div>
                  </div>
                  <div className='container-button-menu mb-4'>
                    <button
                      className='button-general'
                      type='button'
                      onClick={() => handleMenu()}
                    >
                      <img
                        className='button-card-icon'
                        src={points}
                        alt={`${t('SHOW_MENU')}`}
                      />
                    </button>
                    {showMenu && <Menu />}
                  </div>
                </div>
              </div>
            </div>
            <div className='container-margin'>
              <div className='container-flex-block py-4'>
                <div className='col-12 col-md-4 plan-card mb-md-0 mb-3  margin-right-2'>
                  <span className='sub-title'>{`${t('FILTER_BY_DATE')}`}</span>
                  <Calendar onChange={onChange} />
                  <button
                    className='button-fifth'
                    type='button'
                    onClick={() => {
                      getData(urlId)
                    }}
                  >
                    {`${t('SEARCH')}`}
                  </button>
                </div>
                <div className='col-12 col-md-8 plan-card'>
                  <ByTimeDashboard
                    data={chartData}
                    type={'qr-code'}
                    dateRange={`${formatDateLong(
                      String(fromDateSelected)
                    )} - ${formatDateLong(String(toDateSelected))}`}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <DialogModal
          title={`${t('EDIT_LINK')}`}
          open={openEdit}
          handleClose={() => setOpenEdit(false)}
        >
          <div className='d-flex flex-column'>
            <EditQrForm
              data={data}
              onSubmit={handleSubmitEdit}
              handleClose={handleCloseEdit}
            />
          </div>
        </DialogModal>

        <DialogModal
          title={`${t('QR_CREATED')}`}
          open={openDownload}
          handleClose={() => setOpenDownload(false)}
          className='modal-top-red'
        >
          <>
            <div className='d-flex flex-column align-items-center'>
              <QRCodeDownload qrData={data} />
            </div>
          </>
        </DialogModal>
      </div>
    </>
  )
}

export default LinkDetail
